
import axios from 'axios';
const API_URL = process.env.VUE_APP_API_URL;


export function refreshToken() {

    var self = this;
    return new Promise((resolve, reject) => {
        var body = {
            refreshToken: localStorage.getItem("refreshToken")
        }
        axios.post(API_URL + "/emsweb/token", body).then(resposta => {
            if (!resposta.data.Error){
                localStorage.setItem('token', resposta.data.token);
                localStorage.setItem('refreshToken', resposta.data.refreshToken);
                resolve(true)
            }
            else {
                reject("Erro interno do servidor.");
            }
        }).catch(()=>{
            reject("Erro interno do servidor.");
        })
    })

}